import words_3 from './words/words-3'
import words_4 from './words/words-4'
import words_5 from './words/words-5'
import words_6 from './words/words-6'
import words_7 from './words/words-7'

const cards = {
	3: words_3,
	4: words_4,
	5: words_5,
	6: words_6,
	7: words_7
}

export default cards


// WEBPACK FOOTER //
// ./src/data/words.js